export const ModalSeparator = () => (
  <div style={{ borderBottom: "1px solid #2D3542" }} />
);
